module.exports = __webpack_public_path__ + "img/co-branding-logos-primary.20825f35.png";